export default function variantSwitch(_ref) {
  var statement = _ref.statement,
      variants = _ref.variants;
  return statement !== undefined && variants[statement] || null;
}
//# sourceMappingURL=variantSwitch.js.map